import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  Grid, Dialog,
  DialogTitle as MuiDialogTitle, Typography, Button, ButtonGroup,
  IconButton, DialogContent as MuiDialogContent
} from '@material-ui/core'

import { Close as CloseIcon } from '@material-ui/icons'

import { makeStyles } from '@material-ui/core/styles'
import { exportCaptures } from '../../../redux/actions/violations'

import { usePromiseTracker } from 'react-promise-tracker'

import { Toast } from '../../../utils'

const useStyles = makeStyles((theme) => ({
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    },
    width: '100%'
  },
  greenText: {
    color: '#97b557'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  exportDialog: {
    zIndex: '1050 !important'
  }
}))

const ExportCaptures = ({ toggleModal, open }) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const Filter = useSelector(state => state.selection.Filter)

  const downloadFile = async (type) => {
    dispatch(exportCaptures(Filter, type, () => { exportModalToggle() }, (err) => {
      Toast.fire({
        icon: 'error',
        title: err
      })
    }))
  }

  const exportModalToggle = () => {
    toggleModal()
  }

  const { promiseInProgress } = usePromiseTracker()

  return (
    <>
      <Dialog open={open} onClose={exportModalToggle} className={classes.exportDialog} fullWidth maxWidth='md'>
        <MuiDialogTitle disableTypography>
          <Typography variant='h4' color='primary' classes={{ colorPrimary: classes.greenText }} className='font-weight-bold'>Choose Your Export Method</Typography>
          <IconButton aria-label='close' className={classes.closeButton} onClick={exportModalToggle}>
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <Grid container direction='row'>
            <Grid item container direction='column'>
              <Grid item container direction='row' alignItems='center' justify='space-between'>
                <Grid item>
                  <Typography>Select an export option. Your report will download as an attachment.</Typography>
                </Grid>

                <Grid item>
                  <ButtonGroup disableElevation variant='contained' color='primary'>
                    <Button disabled={promiseInProgress} variant='contained' onClick={() => { downloadFile('pdf') }} className={classes.blueBtn}>pdf</Button>
                    <Button disabled={promiseInProgress} variant='contained' onClick={() => { downloadFile('csv') }} className={classes.blueBtn}>csv</Button>
                  </ButtonGroup>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MuiDialogContent>
      </Dialog>
    </>
  )
}

export default ExportCaptures
